import React, { useEffect, useState, useRef } from "react";
import {
  getReleaseRules,
  editReleaseRules,
  getReleaseCycle,
  editReleaseCycle,
  getCompanyList,
  getPositionList,
  addRules,
  editRule,
} from "@/api/operation";
import {
  Button,
  InputNumber,
  Icon,
  Popconfirm,
  Divider,
  message,
  Table,
} from "antd";
import RuleTable from "./RuleTable";

import Modal from "./Modal";
import EditTable from "./EditTable";
import ConfirmModal from "./ConfirmModal";
import "./index.scss";

const Page = (props) => {
  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const [isEditReleaseRules, setIsEditReleaseRules] = useState(false);

  const ruleRef = useRef(null);

  const [least, setLeast] = useState("-");

  const [inputValue, setInputValue] = useState();

  const [cycleData, setCycleData] = useState([]);

  const [currentRule, setCurrentRule] = useState({});

  const [ruleVisible, setRuleVisible] = useState(false);

  const [ruleEditVisible, setRuleEditVisible] = useState(false);

  const [companyList, setCompanyList] = useState([]);

  const [positionList, setPositionList] = useState([]);

  const [cycleEditingIndex, setCycleEditingIndex] = useState(-1);

  const fetchReleaseRules = () => {
    getReleaseRules().then((res) => {
      if (res.success) {
        setLeast(res.data.least);
        setInputValue(res.data.least);
      }
    });
  };

  const fetchReleaseCycle = () => {
    getReleaseCycle().then((res) => {
      if (res.success) {
        setCycleData(
          res.data.map((item, index) => ({
            index: index + 1,
            cycle: item,
          }))
        );
      }
    });
  };

  const fetchCompanyList = () => {
    getCompanyList().then((res) => {
      if (res.success) {
        setCompanyList(
          res.data.map((item, index) => ({
            label: item.name,
            value: item.companyId,
          }))
        );
      }
    });
  };

  const fetchPositionList = () => {
    getPositionList().then((res) => {
      if (res.success) {
        setPositionList(
          res.data.map((item, index) => ({
            label: item.name,
            value: item.pointId,
          }))
        );
      }
    });
  };

  useEffect(() => {
    fetchReleaseRules();
    fetchReleaseCycle();

    fetchCompanyList();
    // fetchPositionList();
  }, []);

  useEffect(() => {}, []);

  const handleEdit = () => {
    setIsEditReleaseRules(true);
  };

  const handleChangeRelease = (value) => {
    setInputValue(value);
  };

  const handleSaveRelease = () => {
    editReleaseRules({ least: inputValue }).then((res) => {
      if (res.success) {
        setIsEditReleaseRules(false);
        fetchReleaseRules();
      }
    });
  };

  const handleAddCycle = () => {
    if (cycleEditingIndex !== -1) {
      message.error("请先编辑完整投放周期！");
      return;
    }
    cycleData.push({ index: cycleData.length + 1, cycle: 0 });
    setCycleData([...cycleData]);
    setCycleEditingIndex(cycleData.length);
  };

  const footer = () => {
    return (
      <div className="footer">
        <Icon type="plus" />
        <div onClick={handleAddCycle}>添加投放周期</div>
      </div>
    );
  };

  const handleEditCycle = (index) => {
    setCycleEditingIndex(index);
  };

  const handleCycleBlur = () => {
    editReleaseCycle(cycleData.map((item) => item.cycle)).then((res) => {
      if (res.success) {
        setCycleEditingIndex(-1);
        fetchReleaseCycle();
      }
    });
  };

  const handleCycleChange = (value, index) => {
    cycleData.splice(index - 1, 1, { ...cycleData[index - 1], cycle: value });
    setCycleData([...cycleData]);
  };

  const handleDeleteCycle = (index) => {
    cycleData.splice(index - 1, 1);
    setCycleData([...cycleData]);
    editReleaseCycle(cycleData.map((item) => item.cycle)).then((res) => {
      if (res.success) {
        setCycleEditingIndex(-1);
        fetchReleaseCycle();
      }
    });
  };

  const handleAddRule = () => {
    setRuleVisible(true);
  };

  const handleCancelRule = () => {
    setRuleVisible(false);
  };

  const handleCancelRuleEdit = () => {
    setRuleEditVisible(false);
    setCurrentRule({});
  };

  const handleRuleAdd = (values) => {
    addRules(values).then((res) => {
      if (res.success) {
        message.success("添加规则成功！");
        setRuleVisible(false);
        ruleRef.current.fetchList();
      }
    });
  };

  const handleEditRule = (current) => {
    setRuleEditVisible(true);
    setCurrentRule(current);
  };

  const [confirmVisible, setConfirmVisible] = useState(false);

  const [tooltip, setTooltip] = useState([]);

  const [editData, setEditData] = useState([]);

  const handleConfirmEditRule = (values) => {
    let tooltip = [];
    if (values.pointPrice !== currentRule.pointPrice) {
      tooltip.push(
        `确认修改点位费用？修改后${currentRule.cycle}天收费${values.pointPrice}元，并在当前周期结束后按照此标准收费。`
      );
    }
    if (values.advertisementPrice !== currentRule.advertisementPrice) {
      tooltip.push(
        `确认修改屏保费用？修改后${currentRule.cycle}天收费${values.advertisementPrice}元，并在当前周期结束后按照此标准收费。`
      );
    }
    if (tooltip.length === 0) {
      handleEditRuleRequest(values);
    } else {
      setTooltip([...tooltip]);
      setConfirmVisible(true);
      setEditData(values);
    }
  };

  const handleEditRuleRequest = (values) => {
    editRule({
      ...values,
      pointChargeRuleId: currentRule.pointChargeRuleId,
    }).then((res) => {
      if (res.success) {
        message.success("编辑计费规则成功!");
        setConfirmVisible(false);
        setCurrentRule({});
        setRuleVisible(false);
        setRuleEditVisible(false);
        ruleRef.current.fetchList();
      }
    });
  };

  const handleConfirm = () => {
    setConfirmVisible(false);
    handleEditRuleRequest(editData);
  };

  return (
    <div className="position">
      <div className="add">
        <div className="line-one">
          <div className="title">增设规则设置</div>
          {!isEditReleaseRules ? (
            <Button type="primary" size={"small"} onClick={handleEdit}>
              修改规则
            </Button>
          ) : (
            <div className="btn-group">
              <Button
                onClick={() => {
                  setIsEditReleaseRules(false);
                  setInputValue(least);
                }}
                size={"small"}
                className="mr-16"
              >
                取消
              </Button>
              <Button type="primary" size={"small"} onClick={handleSaveRelease}>
                保存
              </Button>
            </div>
          )}
        </div>
        <div className="line-two">
          <div className="title">规则一</div>
          <div className="action">
            <div>{`点位最少增设`}</div>
            <div>
              {isEditReleaseRules ? (
                <div style={{ position: "relative" }} className="ml-8">
                  <InputNumber
                    value={inputValue}
                    onChange={handleChangeRelease}
                    size={"small"}
                    min={0}
                  />
                  <div className="unit">个</div>
                </div>
              ) : (
                `${least}个`
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="delivery">
        <div className="title bg-white">投放周期设置</div>
        <div className="content bg-white">
          <Table
            columns={[
              {
                title: "ID",
                dataIndex: "id",
                render: (text, record) => record.index,
                width: "25%",
              },
              {
                title: "投放周期",
                dataIndex: "cycle",
                render: (text, record) => {
                  return record.index === cycleEditingIndex ? (
                    <div>
                      <InputNumber
                        value={text}
                        onBlur={handleCycleBlur}
                        onChange={(value) =>
                          handleCycleChange(value, record.index)
                        }
                        formatter={(value) => `${value}天`}
                        parser={(value) => value.replace("天", "")}
                        min={0}
                      />
                    </div>
                  ) : (
                    `${text} 天`
                  );
                },
                width: "50%",
              },
              {
                title: "操作",
                dataIndex: "",
                render: (text, record) => (
                  <div>
                    {/* <a href="#" onClick={() => handleEditCycle(record.index)}>
                      编辑
                    </a>
                    <Divider type={"vertical"} /> */}
                    <Popconfirm
                      title="确认删除?"
                      onConfirm={() => handleDeleteCycle(record.index)}
                    >
                      <a href="#">删除</a>
                    </Popconfirm>
                  </div>
                ),
              },
            ]}
            dataSource={cycleData}
            footer={footer}
            pagination={false}
          />
        </div>
      </div>

      <div className="delivery">
        <div className="title bg-white">计费规则设置</div>

        <Modal
          companyList={companyList}
          positionList={positionList}
          current={{}}
          visible={ruleVisible}
          onCancel={handleCancelRule}
          onAdd={handleRuleAdd}
          cycleData={cycleData}
        />

        <RuleTable
          ref={ruleRef}
          onEdit={handleEditRule}
          cycleData={cycleData}
          onAdd={handleAddRule}
        />

        <EditTable
          visible={ruleEditVisible}
          companyList={companyList}
          current={currentRule}
          onCancel={handleCancelRuleEdit}
          onEdit={handleConfirmEditRule}
          cycleData={cycleData}
        />

        <ConfirmModal
          visible={confirmVisible}
          tooltip={tooltip}
          onConfirm={handleConfirm}
          onCancel={() => setConfirmVisible(false)}
        />
      </div>
    </div>
  );
};
export default Page;
